var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('div',{staticClass:"notfound"},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("您访问的页面没有找到！")]),_c('el-button',{attrs:{"size":"large","type":"primary"},on:{"click":_vm.goback}},[_vm._v(" 返 回 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }